import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'

import { enqueue } from 'common/notifier'

type RequestResponse<Q> = {
  loading: boolean
  error: string | null
  fetch: (params?: Q) => Promise<any>
}

export const useRequest = <T, Q = null | undefined>(
  apiCall: (params: Q) => Promise<T>,
  setData?: (data: T) => any,
  onError?: (error: any) => any
): RequestResponse<Q> => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  const fetchData = useCallback(
    async (params) => {
      try {
        const response = await apiCall(params)
        setData?.(response)
        return response
      } catch (error) {
        dispatch(enqueue(error))
        setError(error)
        onError?.(error)
      } finally {
        setLoading(false)
      }
    },
    [apiCall, dispatch, onError, setData]
  )

  return { loading, error, fetch: fetchData }
}
